import { gql } from 'apollo-boost';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useQuery } from '@apollo/react-hooks';
import InfoArea from '../InfoArea';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Loading from './Loading';
import Error from './Error';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  link: {
    margin: theme.spacing(1)
  },
  listItem: {
    padding: theme.spacing(1, 1, 1, 1)
  },
  media: {
    paddingBottom: '60%',
    height: 'auto',
    width: '100%'
  },
  progress: {},
  spinner: {
    height: '100vh'
  },
  textCenter: {
    textAlign: 'center!important'
  }
}));

export const QUERY = gql`
  {
    customersInStoreOffers {
      id
      uuid
      name
      listImageUrl
    }
  }
`;

export default function InStoreOffersIndex() {
  const classes = useStyles();

  const { loading, error, data } = useQuery(QUERY);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error error={error} />;
  }

  return (
    <div className={classes.root}>
      <div className={classes.textCenter}>
        <Grid container justify="center">
          <Grid item xs={12}>
            <InfoArea
              title="Select In-Store Offer"
              description="Select the in-store offer that applies to your receipt"
              icon={ShoppingCartIcon}
              iconColor="success"
              vertical
            />
          </Grid>
        </Grid>
      </div>
      <List component="nav">
        {data.customersInStoreOffers.map(({ id, name, listImageUrl }) => (
          <ListItem key={name} button className={classes.listItem}>
            <Box width="100%">
              <Card className={classes.card}>
                <a href={`/react/customers/in_store_offers/${id}`} title={name}>
                  <CardActionArea>
                    <CardMedia className={classes.media} image={listImageUrl} />
                  </CardActionArea>
                </a>
              </Card>
            </Box>
          </ListItem>
        ))}
      </List>
    </div>
  );
}
